import { IGridParamsQueryParam } from "./product-collection-views/product-collection-grid-view/tool-panels";

export const getGridParamsFromLocation = ({ query }): IGridParamsQueryParam => {
    let { gridParams } = query;
    try {
        gridParams = JSON.parse(gridParams);
    } catch (e) {
        gridParams = {};
    }

    return gridParams;
};
